import { safeParse } from "./cartUtils";
import { CounterType } from "@/common-components-src/components/UKCounter";

export const freeTrack = (freight: any) => {
    return {
        displayText: freight?.info["HJM-M#basic&basic"]?.coudanMsg || "",
        freeShipStatus: freight?.info["HJM-M#basic&basic"]?.isFreeFreight ? "1" : "0",
    };
};
export const productCardTrack = (item: any, skuId: any, index: number) => {
    if (!item) {
        return {
            skuid: "",
            skuStatus: "",
            index: -1,
            skuNum: "",
            single_promotion: "",
            amount_promotion: "",
            time_label: "",
        };
    }
    const isUnusableItem = !!item.info["C-M#abstractUnusableProductItem&basic"];
    const stockCode = item?.info?.["HJM-M#cartProduct&stockInfo"]?.stockCode
    let skuStatus = stockCode === 1 ? "缺货" : "在线";
    if (isUnusableItem) {
        skuStatus = "下架";
    }
    const skuNum = isUnusableItem ? item?.info["C-M#abstractUnusableProductItem&basic"]?.num : item?.info["C-M#productItem&basic"]?.num;
    // 提取 productMarkInfo 的值 标签
    const productMarkInfoValues =
        item?.info["HJM-M#cartProduct&extInfo"]?.productMarkInfo;
    const productMarkInfoText = Object.values(productMarkInfoValues || []);
    let single_promotion = "";
    let amount_promotion = "";
    let time_label = "";
    if (productMarkInfoText.length > 0) {
        productMarkInfoText
            .map((markInfo) => {
                const promotionType = safeParse(markInfo)?.promotionType;
                const text = safeParse(markInfo)?.text;
                if (promotionType === 1) {
                    single_promotion = text;
                } else if (promotionType === 2) {
                    amount_promotion = text;
                } else if (promotionType === 3) {
                    time_label = text;
                }
            })
    }
    return {
        skuid: skuId,
        skuStatus,
        index,
        skuNum,
        single_promotion,
        amount_promotion,
        time_label,
    };
};

export const counterTrack = (skuId: any, pos: string) => {
    let clickPos = "";
    if (pos === CounterType.add) {
        clickPos = "加号";
    } else if (pos === CounterType.reduce) {
        clickPos = "减号";
    } else if (pos === CounterType.input) {
        clickPos = "数字区";
    }
    return {
        skuid: skuId,
        clickPos,
    };
};

export const selectSkuIds = (productItems: any[]) => {
    if (!productItems || productItems.length < 1) {
        return [];
    }
    // 初始化 skuId 数组
    const skuIdArray: string[] = [];
    // 遍历选中的商品并提取 skuId
    productItems
        .filter((item) => item?.info["C-M#productItem&basic"]?.activeCheck === 1)
        .forEach((item: any) => {
            const skuId = item?.info?.["C-M#productItem&core"]?.skuId;
            if (skuId) {
                skuIdArray.push(skuId);
            }
        });
    return skuIdArray;
};

export const selectSkuIdAndNum = (productItems: any[]) => {
    if (!productItems || productItems.length < 1) {
        return { skuList: [] }; // 返回一个包含空对象的数组
    }
    // 初始化 skuList 数组
    const skuList: { skuid: string; skuNum: string }[] = [];
    // 遍历选中的商品并提取 skuId 和 num
    productItems
        .filter((item) => item?.info["C-M#productItem&basic"]?.activeCheck === 1)
        .forEach((item: any) => {
            const skuId = item?.info?.["C-M#productItem&core"]?.skuId;
            const num = item?.info["C-M#productItem&basic"]?.num;
            if (skuId) {
                skuList.push({ skuid: skuId, skuNum: num || "" }); // 如果 num 为 undefined，则默认为 0
            }
        });
    return { skuList };
};
